export default __webpack_public_path__ + "static/media/a028-3.04e0eca0.png";